// Notification Data Model
export const notificationModel = {
  // Notification Collection Structure
  collection: 'notifications',
  
  // Default Notification Document Structure
  defaultDocument: {
    id: '', // Auto-generated by Firestore
    userId: '', // User who receives the notification
    type: '', // order_new, order_status, bid_new, review_new, chat_new
    title: '', // Notification title
    message: '', // Notification message
    data: {}, // Additional data (orderId, productId, etc.)
    
    // Status
    read: false, // Whether notification has been read
    readAt: null, // When notification was read
    
    // Metadata
    createdAt: '', // ISO string
    updatedAt: '' // ISO string
  },
  
  // Notification Types
  types: {
    ORDER_NEW: 'order_new', // ออเดอร์ใหม่
    ORDER_STATUS: 'order_status', // สถานะออเดอร์เปลี่ยน
    BID_NEW: 'bid_new', // มีการเสนอราคาใหม่
    REVIEW_NEW: 'review_new', // มีรีวิวใหม่
    CHAT_NEW: 'chat_new', // มีข้อความใหม่
    AUCTION_ENDING: 'auction_ending', // ประมูลใกล้หมดเวลา
    AUCTION_WON: 'auction_won', // ชนะประมูล
    AUCTION_WINNER_CONFIRMED: 'auction_winner_confirmed', // ผู้ขายยืนยันผู้ชนะ
    AUCTION_CANCELLED: 'auction_cancelled', // ประมูลถูกยกเลิก
    ORDER_CREATED: 'order_created', // ออเดอร์ถูกสร้าง
    BUYER_REQUEST_OFFER: 'buyer_request_offer', // มีคนเสนอราคาในประกาศหาสินค้า
    PAYMENT_PROOF_UPLOADED: 'payment_proof_uploaded', // ผู้ซื้ออัพโหลดหลักฐานการโอนแล้ว
    ADMIN_MIDDLEMAN_ORDER: 'admin_middleman_order', // ออเดอร์ที่ใช้แอดมินเป็นตัวกลาง
    VIDEO_CALL_REQUEST: 'video_call_request', // มี Video Call Request ใหม่
    VIDEO_CALL_APPROVED: 'video_call_approved', // Video Call ถูกอนุมัติ
    VIDEO_CALL_REJECTED: 'video_call_rejected', // Video Call ถูกปฏิเสธ
    VIDEO_CALL_REMINDER: 'video_call_reminder', // แจ้งเตือนก่อน Video Call
    VIDEO_CALL_INCOMING: 'video_call_incoming', // มี Video Call เข้ามา (incoming call)
    PACKAGE_EXPIRING: 'package_expiring', // แพ็กเกจใกล้หมดอายุ
    CAMPAIGN_APPROVED: 'campaign_approved', // Campaign ถูกอนุมัติ
    CAMPAIGN_REJECTED: 'campaign_rejected', // Campaign ถูกปฏิเสธ
    CAMPAIGN_EXPIRING: 'campaign_expiring', // Campaign ใกล้หมดอายุ
    CAMPAIGN_EXPIRED: 'campaign_expired', // Campaign หมดอายุ
    TEAM_REQUEST: 'team_request', // มีคำขอเข้าร่วมทีม
    TEAM_INVITATION: 'team_invitation', // ได้รับคำเชิญเข้าทีม
    TEAM_APPROVED: 'team_approved', // คำขอเข้าร่วมทีมถูกอนุมัติ
    TEAM_REJECTED: 'team_rejected', // คำขอเข้าร่วมทีมถูกปฏิเสธ
    TEAM_MEMBER_REMOVED: 'team_member_removed', // ถูกลบออกจากทีม
    SHIFT_ASSIGNED: 'shift_assigned', // ได้รับมอบหมายเวร
    SHIFT_SWAP_REQUEST: 'shift_swap_request', // มีคำขอแลกเวร
    SHIFT_SWAP_APPROVED: 'shift_swap_approved', // คำขอแลกเวรถูกอนุมัติ
    SHIFT_SWAP_REJECTED: 'shift_swap_rejected', // คำขอแลกเวรถูกปฏิเสธ
    SHIFT_REMINDER: 'shift_reminder' // แจ้งเตือนเวรใกล้ถึงเวลา
  },
  
  // Notification Icons
  icons: {
    order_new: '🛒',
    order_status: '📦',
    bid_new: '💰',
    review_new: '⭐',
    chat_new: '💬',
    auction_ending: '⏰',
    auction_won: '🏆',
    auction_winner_confirmed: '✅',
    auction_cancelled: '❌',
    order_created: '📦',
    buyer_request_offer: '📢',
    payment_proof_uploaded: '💳',
    admin_middleman_order: '🛡️',
    video_call_request: '📹',
    video_call_approved: '✅',
    video_call_rejected: '❌',
    video_call_reminder: '⏰',
    video_call_incoming: '📞',
    package_expiring: '⏰',
    campaign_approved: '✅',
    campaign_rejected: '❌',
    campaign_expiring: '⏰',
    campaign_expired: '🔴',
    team_request: '👥',
    team_invitation: '📨',
    team_approved: '✅',
    team_rejected: '❌',
    team_member_removed: '🚫',
    shift_assigned: '📅',
    shift_swap_request: '🔄',
    shift_swap_approved: '✅',
    shift_swap_rejected: '❌',
    shift_reminder: '⏰'
  },
  
  // Create notification helper
  createNotification: (userId, type, title, message, data = {}) => {
    return {
      ...notificationModel.defaultDocument,
      userId,
      type,
      title,
      message,
      data,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  }
};

export default notificationModel;


